<template>
  <div class="min-h-screen  flex items-center justify-center p-4">
    <div class="border rounded-2xl p-8 max-w-md w-full shadow-2xl">
      <!-- Header -->
      <div class="text-center mb-8">
        <h1 class="text-white text-3xl font-bold mb-2">ناسنا</h1>
        <p class="text-gray-400 text-sm">خطوة 1 من 2</p>
        <h2 class="text-white text-xl font-semibold mt-4">اختر الباقة المناسبة</h2>
      </div>

      <!-- Plans Selection -->
      <div class="space-y-4 mb-8" dir="rtl">
        <div 
          v-for="plan in plans" 
          :key="plan.id"
          @click="selectPlan(plan.id)"
          :class="[
            'border rounded-lg p-4 cursor-pointer transition-all duration-200 relative',
            selectedPlan === plan.id 
              ? 'border-pink-500 bg-pink-500/10' 
              : 'border-gray-600 bg-gray-700/50 hover:border-gray-500'
          ]"
        >
          <!-- Radio Button -->
          <div class="absolute top-4 right-4">
            <div :class="[
              'w-5 h-5 rounded-full border-2 flex items-center justify-center',
              selectedPlan === plan.id 
                ? 'border-pink-500 bg-pink-500' 
                : 'border-gray-400'
            ]">
              <div 
                v-if="selectedPlan === plan.id"
                class="w-2 h-2 bg-white rounded-full"
              ></div>
            </div>
          </div>

          <div class="flex justify-between items-center pr-12">
            <!-- Plan Info (Right Side) -->
            <div class="text-right">
              <h3 class="text-white font-semibold text-lg mb-1">{{ plan.name }}</h3>
              <p class="text-gray-400 text-sm mb-2">{{ plan.description }}</p>
            </div>
            
            <!-- Price Section (Left Side) -->
            <div class="text-left  rounded-lg px-4 py-3 min-w-[120px]">
              <div class="text-gray-400 text-xs mb-1">ابتداء من</div>
              <div class="text-white font-bold text-xl">{{ plan.price.split(' ')[0] }}</div>
              <div class="text-gray-400 text-xs">جنيه/{{ getPeriod(plan.name) }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="space-y-3 mx-2">
        <button 
          @click="proceedWithPlan"
          :disabled="!selectedPlan"
          :class="[
            'w-full py-3 rounded-lg font-semibold transition-all duration-200',
            selectedPlan 
              ? 'bg-pink-500 hover:bg-pink-600 text-white' 
              : 'bg-gray-600 text-gray-400 cursor-not-allowed'
          ]"
        >
          المتابعة
        </button>
        
        <button 
          @click="goBack"
          class="w-full border py-3 rounded-lg font-semibold text-gray-300 hover:text-white transition-colors duration-200"
        >
          الرجوع
        </button>
      </div>
    </div>
  </div>
</template>

<script >
export default {
  name: "SudaniPlans",
  data() {
    return {
      selectedPlan: null,
      plans: [
        {
          id: 1,
          name: "الباقة اليومية",
          description: "يمكنك الدفع بالاستخدام",
          price: "700 جنيه سوداني",
          url: "https://sudanipay.com/subscription/nasna/nasna",
        },
        {
          id: 2,
          name: "الباقة الأسبوعية",
          description: "يمكنك الدفع بالاستخدام",
          price: "2800 جنيه سوداني",
          url: "https://sudanipay.com/subscription/nasna/NasnaTVWeekly",
        },
        {
          id: 3,
          name: "الباقة الشهرية",
          description: "يمكنك الدفع بالاستخدام",
          price: "9900 جنيه سوداني",
          url: "https://sudanipay.com/subscription/nasna/NasnaTVMonthly",
        },
      ],
    };
  },
  methods: {
    selectPlan(planId) {
      this.selectedPlan = planId;
    },
    getPeriod(planName) {
      if (planName.includes('اليومية')) return 'اليوم';
      if (planName.includes('الأسبوعية')) return 'الأسبوع';
      if (planName.includes('الشهرية')) return 'الشهر';
      return 'اليوم';
    },
    proceedWithPlan() {
      if (this.selectedPlan) {
        const selectedPlanData = this.plans.find(plan => plan.id === this.selectedPlan);
        console.log('Selected Plan:', selectedPlanData);
        
        // Redirect to the selected plan's URL
        if (selectedPlanData && selectedPlanData.url) {
          window.location.href = selectedPlanData.url;
        } else {
          console.error('No URL found for selected plan');
        }
      }
    },
    goBack() {
      // Add back navigation logic
      this.$router.go(-1);
    }
  },

};
</script>

<style scoped>
/* Custom styles for better RTL support */
.plan-card {
  direction: rtl;
}

/* Custom radio button animation */
.radio-button {
  transition: all 0.2s ease-in-out;
}

/* Hover effects */
.plan-option:hover {
  transform: translateY(-2px);
}

/* Focus styles for accessibility */
.plan-option:focus {
  outline: 2px solid #ec4899;
  outline-offset: 2px;
}

/* Button press animation */
button:active {
  transform: scale(0.98);
}
</style>